// extracted by mini-css-extract-plugin
export default {"content":"AppointmentWhen_content__duFDL"};